import { AssessmentType } from "types/graphql-schema";

import { classNames } from "@helpers/css";

const OPTIONS: { value: AssessmentType; title: string; shortTitle: string }[] =
  [
    {
      value: AssessmentType.Performance,
      title: "Downward Results",
      shortTitle: "Downward",
    },
    {
      value: AssessmentType.Manager,
      title: "Upward Results",
      shortTitle: "Upward",
    },
  ];

// Segmented toggle to switch a review report between its downward (performance)
// and upward (manager) results. Sized/styled to match the report's inputs.
const ReportTypeToggle = ({
  activeType,
  onChange,
}: {
  activeType: AssessmentType;
  onChange: (type: AssessmentType) => void;
}) => (
  <div className="inline-flex h-[32px] shrink-0 divide-x rounded-[6px] border bg-white text-sm">
    {OPTIONS.map((option, index) => (
      <button
        key={option.value}
        type="button"
        onClick={() => onChange(option.value)}
        className={classNames(
          "whitespace-nowrap px-3",
          index === 0 ? "rounded-l-[6px]" : "rounded-r-[6px]",
          activeType === option.value
            ? "bg-blue-50 text-blue-800"
            : "text-gray-600 hover:bg-gray-50",
        )}
      >
        <span className="@4xl/layout-main:hidden">{option.shortTitle}</span>
        <span className="hidden @4xl/layout-main:inline">{option.title}</span>
      </button>
    ))}
  </div>
);

export default ReportTypeToggle;
